import { type GridCellProps } from '@progress/kendo-react-grid'
import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type CoreMember } from '../hooks/useMainQuery'

export type CommandsCellProps = Omit<GridCellProps, 'dataItem'> & {
  dataItem: CoreMember
}

export const CommandsCell = ({ dataItem: coreMember }: CommandsCellProps) => {
  const { t } = useTranslation()
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleDeleteButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ coreMember, dialogType: 'delete' })
  }, [coreMember, setDialogInfo])

  return (
    <td>
      <HStack backgroundColor="transparent" justify="center" spacing={0}>
        <StyledButton
          buttonStyle="alert"
          fillMode="outline"
          icon="delete"
          onClick={handleDeleteButtonClick}
        >
          {t('delete')}
        </StyledButton>
      </HStack>
    </td>
  )
}
